import { useState, useCallback } from 'react';
export function useUnderwritingErrors() {
  const [underwritingErrors, setErrors] = useState<Array<string>>([]);

  const setUnderwritingErrors = useCallback(
    (status: any) => {
      setErrors(
        (status?.response?.data?.metadata?.underwritingErrors ?? []).map(
          (err: { errorMessage: string }) => err.errorMessage
        )
      );
    },
    [setErrors]
  );

  const hasUnderwritingErrors = (status: any) => {
    const errors = status?.response?.data?.metadata?.underwritingErrors ?? [];
    return errors.length > 0;
  };

  return { underwritingErrors, setUnderwritingErrors, hasUnderwritingErrors };
}
